import { Injectable } from '@angular/core';
import {
	CanActivate,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth/auth.service';
import { NavController } from '@ionic/angular';

@Injectable({
	providedIn: 'root',
})
export class GuestGuard implements CanActivate {
	constructor(
		private authService: AuthService,
		private navController: NavController
	) {}
	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	):
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree>
		| boolean
		| UrlTree {
		if (this.authService.user) {
			return this.navController.navigateForward('/auth/home');
		}
		return true;
	}
}
